import React, {useState} from 'react';
import PortfolioCard from './PortfolioCard';

function Projects() {
  const [projects] = useState([
    {
      name: 'Sleep Tracker',
      gitHubLink: 'https://github.com/Sleep-tracker-2/Front_End',
      projectLink: 'https://sleep-tracker.now.sh/',
      description:
        'Sleep Tracker was Build Week project in Lambda. It keeps track of your sleep and displays it on a graph. ',
      builtWith: ['React', 'Express', 'SemanticUI'],
      year: 2020,
    },
    {
      name: 'TidyHive',
      gitHubLink: 'https://github.com/Lambda-School-Labs/homerun-fe/',
      projectLink: 'https://tidyhive-fe.herokuapp.com/',
      description:
        'TidyHive is a task-management tool that allows you to organize your work in a systematic and organized manner.',
      builtWith: ['React', 'Redux', 'Express', 'TailwindCSS'],
      year: 2020,
    },
    {
      name: "Conway's Game of Life",
      gitHubLink: 'https://github.com/Bobj2018/Conways-Game-of-Life',
      projectLink: 'https://conways-game-of-life-60vmjxks8.vercel.app/',
      description:
        'Created a simulation of the popular algorithm. The graph allows you to change the state of a specific cell and run through the algorithm to determine whether or not it is alive or dead.',
      builtWith: ['React', 'Redux', 'CSS3'],
      year: 2020,
    },
    {
      name: 'Lottery Game 2.0',
      gitHubLink: 'https://github.com/Bobj2018/Lottery-Game-2.0',
      projectLink: 'https://lottery-game-v2.now.sh/',
      description:
        'Displays a list of random numbers (of the players choosing) and the player tries to guess the number.',
      builtWith: ['React', 'Redux', 'MaterialUI'],
      year: 2020,
    },
  ]);

  return (
    <section id="projects" className="px-10 py-4 m-auto bg-white sm:shadow-md sm:w-2/3">
      <h2 className="w-full text-3xl font-bold ">Projects</h2>
      <div className="lg:flex-wrap lg:justify-center lg:flex">
        {projects.map((project, i) => (
          <PortfolioCard key={i} project={project} />
        ))}
      </div>
    </section>
  );
}

export default Projects;
